/** Tiếp đón & Hàng chờ. Real /api/v1/reception/queue. */
import { apiClient } from "./client";
import type { AppointmentAssignState } from "../types/appointment";

export interface ReceptionRow {
  appointmentId: string;
  patientId: string;
  patientCode: string | null;
  patientName: string;
  patientPhone: string | null;
  doctorId: string | null;
  doctorName: string | null;
  serviceName: string | null;
  startAt: string;
  status: "REQUESTED" | "CONFIRMED" | "CHECKED_IN" | "COMPLETED" | "CANCELLED" | "NO_SHOW";
  registrationNo: number | null;
  roomId: string | null;
  roomName: string | null;
  /** #19934 — STT vào phòng (lịch đã có phòng); null = chưa có phòng. */
  roomNo: number | null;
  /** Trạng thái phân công (Booking Policy) — điều khiển nút "Phân công". */
  assignState?: AppointmentAssignState;
  departmentId?: string | null;
  /** Ưu tiên — gọi trước các bệnh nhân thường (STT gốc giữ nguyên). */
  priority?: boolean;
  /** Trạng thái gọi: CALLED / HELD / SKIPPED, hoặc null (đang chờ / theo appointment). */
  queueState?: "CALLED" | "HELD" | "SKIPPED" | null;
  /**
   * #19088 — quầy được chọn bác sĩ cho dòng này ngay bây giờ: ô bác sĩ còn trống, phòng khám không
   * để hệ thống tự xếp (`doctorFill` ≠ AUTO), lịch còn sống. Server quyết, cùng luật với API gán.
   */
  doctorAssignable?: boolean;
}

/** Kết quả gán bác sĩ ở quầy. `offDuty`: bác sĩ không nằm trong Lịch trực của phòng lúc đó. */
export interface DeskDoctorAssignResult {
  appointmentId: string;
  doctorId: string;
  offDuty: boolean;
}

export const receptionApi = {
  /** #19088 — chọn bác sĩ ngay trên dòng hàng chờ. Cần quyền `queue.coordinate`. */
  assignDoctor(appointmentId: string, doctorProfileId: string): Promise<DeskDoctorAssignResult> {
    return apiClient
      .post<DeskDoctorAssignResult>(`/v1/reception/appointments/${appointmentId}/doctor`, {
        doctorProfileId,
      })
      .then((r) => r.data);
  },
  queue(date?: string | null): Promise<ReceptionRow[]> {
    return apiClient
      .get<ReceptionRow[]>("/v1/reception/queue", { params: { date: date ?? undefined } })
      .then((r) => r.data);
  },
};

export const receptionQueryKeys = {
  queue: (date: string) => ["reception-queue", date] as const,
};
